const ExitMini = () => (
  <svg width="25" height="25" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.10178 5.99792L3.05089 8.04881L2.1601 7.15802L4.21099 5.10713L2.14629 3.04244L3.03708 2.15165L5.08797 4.20253L7.15267 2.13784L8.04345 3.02862L5.97876 5.09332L8.04345 7.15802L7.15267 8.04881L5.10178 5.99792Z" fill="#C4C4C4"/>
  </svg>
);
export default ExitMini